export default __webpack_public_path__ + "static/media/lateral-left-demo.ff4dd6dc.png";